var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal2",
    {
      attrs: {
        "show-footer": false,
        title: _vm.$t("message.sendTemplateMessage"),
        className: "template-message-modal",
      },
      on: {
        cancel: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c("div", { staticClass: "template-message-modal" }, [
        _c("div", { staticClass: "template-message-modal-content" }, [
          _c(
            "div",
            { staticClass: "template-message-modal-preview" },
            [
              _c("WABATemplateMessage", {
                attrs: { data: _vm.getPreviewTemplatePayload() },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "template-message-modal-content-editor" }, [
            ["IMAGE", "VIDEO", "DOCUMENT"].includes(_vm.template.templateType)
              ? _c("div", { staticClass: "image-picker" }, [
                  _c("div", { staticClass: "editor-row" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                            },
                            expression:
                              "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                            }",
                          },
                        ],
                        staticClass: "editor-row-title",
                        attrs: {
                          content: "Görseli Özelleştirmek İstiyorsanız.",
                        },
                      },
                      [
                        _vm._v(
                          "\n                            Media\n                            "
                        ),
                        _c("span", { staticClass: "optional" }, [
                          _vm._v(
                            _vm._s(_vm.$t("whatsapp_business_api.optional"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("a-icon", { attrs: { type: "question-circle" } }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.media
                      ? _c("div", { staticClass: "media-preview" }, [
                          _c("div", { staticClass: "media-preview-content" }, [
                            _c("div", { staticClass: "media-image" }, [
                              _c("img", {
                                attrs: { src: _vm.media.data, alt: "" },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "media-preview-name" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.media.name) +
                                  "\n                                "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "media-preview-delete",
                              on: { click: _vm.deleteMedia },
                            },
                            [
                              _c("div", { staticClass: "material-icons" }, [
                                _vm._v("delete"),
                              ]),
                            ]
                          ),
                        ])
                      : _c("div", { staticClass: "media-drag" }, [
                          _c("div", { staticClass: "input" }, [
                            _c("input", {
                              attrs: {
                                type: "file",
                                id: "media-source",
                                accept: _vm.getAcceptType(),
                              },
                              on: { change: _vm.handleFileUpload },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "material-icons" }, [
                            _vm._v("image"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "content" }, [
                            _vm._v("Click here to upload a picture."),
                          ]),
                        ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "description" }, [
                      _c("div", { staticClass: "input-warn" }, [
                        _c("div", [
                          _c("b", [_vm._v("Note:")]),
                          _vm._v(
                            "Following are the file formats and their respective sizes which are\n                                    accepted for upload\n                                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("ul", { staticClass: "list-item" }, [
                          _c("li", [
                            _vm._v("Image: JPEG and PNG (Max size 2 MB)"),
                          ]),
                          _vm._v(" "),
                          _c("li", [_vm._v("Video: MP4 (Max size 20 MB)")]),
                          _vm._v(" "),
                          _c("li", [_vm._v("Document: (Max size 2 MB)")]),
                        ]),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "template-message-modal-params" },
              _vm._l(_vm.params, function (param, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "editor-row" },
                  [
                    _c("div", [_vm._v("Parametre " + _vm._s(index + 1))]),
                    _vm._v(" "),
                    _c("a-textarea", {
                      staticClass: "full-width-textarea",
                      attrs: { placeholder: "Enter value" },
                      model: {
                        value: _vm.params[index],
                        callback: function ($$v) {
                          _vm.$set(_vm.params, index, $$v)
                        },
                        expression: "params[index]",
                      },
                    }),
                  ],
                  1
                )
              }),
              0
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "template-message-modal-actions" },
          [
            _c(
              "SupsisButton",
              {
                attrs: { primary: "" },
                on: {
                  click: function ($event) {
                    _vm.$emit("send", _vm.getPayload())
                  },
                },
              },
              [_vm._v(" Send")]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                attrs: { ghost: "" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [_vm._v("Cancel")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }